
import { defineComponent } from "vue";
import { Header, Account } from "@/types";

export default defineComponent({
  name: "UsersTable",
  props: {
    headers: {
      type: Array as () => Header[],
      required: true,
    },
    members: {
      type: Array as () => Account[],
      required: true,
    },
    selectedUsers: {
      type: Array as () => Account[],
      required: true,
    },
  },
  data() {
    return {
      filterBy: "name",
      ascending: true,
      searchText: "",
      filteredUsers: [] as Account[],
    };
  },
  methods: {
    toggleModal(action: string) {
      this.$emit("toggleModal", action);
    },
    toggleCheckbox(member: Account) {
      this.$emit("update:selectedUsers", member);
    },
    runSingleAction(member: Account, action: string) {
      this.$emit("runSingleAction", member, action);
    },
    setSearchText(data: string): void {
      this.searchText = data;
      if (data.length === 0) {
        this.filteredUsers = Object.assign([], this.members);
      } else {
        this.filteredUsers = this.members.filter((report: Account) => {
          const key = report[this.filterBy as keyof Account] as string;
          return key.toLowerCase().includes(data.toLowerCase());
        });
      }
    },
    setFilterBy(filterBy: string): void {
      if (filterBy === this.filterBy) {
        this.ascending = !this.ascending;
      } else {
        this.filterBy = filterBy;
        this.ascending = true;
      }

      switch (filterBy) {
        case "address":
          this.filteredUsers.sort((a, b) => {
            return this.ascending
              ? a.address.localeCompare(b.address)
              : b.address.localeCompare(a.address);
          });
          break;
        case "contact":
          this.filteredUsers.sort((a, b) => {
            return this.ascending
              ? a.contact.localeCompare(b.contact)
              : b.contact.localeCompare(a.contact);
          });
          break;
        case "type":
          this.filteredUsers.sort((a, b) => {
            return this.ascending
              ? a.type.localeCompare(b.type)
              : b.type.localeCompare(a.type);
          });
          break;
        case "verified":
          this.filteredUsers.sort((a, b) => {
            return this.ascending
              ? Number(a.verified) - Number(b.verified)
              : Number(b.verified) - Number(a.verified);
          });
          break;
        case "name":
        default:
          this.filteredUsers.sort((a, b) => {
            return this.ascending
              ? a.name.localeCompare(b.name)
              : b.name.localeCompare(a.name);
          });
          break;
      }
    },
  },
  mounted() {
    this.filterBy = this.headers[0].key;
    this.filteredUsers = Object.assign([], this.members);
    this.setFilterBy(this.filterBy);
  },
  watch: {
    members: function (data: Account[]) {
      this.filteredUsers = Object.assign([], data);
      this.setFilterBy(this.filterBy);
    },
  },
});
